module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copybreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "pIV"
    }
  }), _vm._v("Copyright © 1998 by Rory Muir")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("First published in paperback in 1998")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved. This book may not be reproduced in whole or in part, in any form (beyond that copying permitted by Sections 107 and 108 of the U.S. Copyright Law and except by reviewers for the public press) without written permission from the publishers.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Set in Ehrhardt by Best-set Typesetter Ltd., Hong Kong")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Printed in Great Britain by St Edmundsbury Press")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Muir, Rory, 1962–")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("   Tactics and the experience of battle in the age of Napoleon/Rory Muir.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("   Includes bibliographical references")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("   ISBN 0–300–07385–2 (cloth)")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("   1. Napoleonic Wars, 1800–1815–Campaigns.  2. Military art and science – France – History – 19th century.  3. Tactics.  I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("  DC151.M9  1998")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("  940.2′7 – dc21       97-44386")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-r"
  }, [_vm._v("CIP")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("A catalogue record for this book is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("ISBN 978-0-300-08270-8 (pbk)")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Illustration acknowledgements:")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Part One: Daily life with Wellington's army, from J.H. Pyne's "), _c('i', [_vm._v("Camp Scenes")]), _vm._v(", 1803.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Part Two: Infantry in Italy, 1796, artist and source unknown. Part Three: Officer and Privates of the 52nd Light Infantry by Charles Hamilton Smith (National Army Museum). Part Four: Charge of Le Marchant's brigade at Salamanca, artist and source unknown.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-864f5876","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyright.vue
// module id = 63
// module chunks = 0